import classNames from 'classnames';
import { useMemo } from 'react';

import { LeaderboardMultiplier } from '@/types/leaderboard.types';
import OptionalComponent from '@ui/optional-component/optional-component';
import { ICONS } from '@ui/icons/types';
import Icon from '@ui/icons/icon';
import LeaderboardActionSettingCard from './action-setting';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

interface LeaderboardActionSettingsProps {
  actions: LeaderboardMultiplier[];
  editActions: () => void;
  label?: string;
  panel?: boolean;
  loadingActions: boolean;
}

const LeaderboardActionSettings: React.FC<LeaderboardActionSettingsProps> = ({
  actions,
  editActions,
  label = 'Action Settings',
  panel,
  loadingActions,
}) => {
  // boolean for determining if at least one action is enabled
  // used to show empty state if needed
  const hasEnabledActions = useMemo(() => {
    return !!actions.length && !!actions.some((action) => action.is_on === true);
  }, [actions]);

  return (
    <div className="leaderboard-action-settings-wrapper">
      <div className={classNames('leaderboard-action-settings-container', { 'leaderboard-empty': !actions.length })}>
        <div className="leaderboard-action-settings-header">
          <Text className="leaderboard-settings-label">{label}</Text>
          <OptionalComponent display={hasEnabledActions && !panel}>
            <Button hoverOpacity={0.8} disabled={loadingActions} className="clear-button L2" onClick={editActions}>
              <Text color={getThemeColorCSSVariable()}>Edit Actions</Text>
            </Button>
          </OptionalComponent>
        </div>
        {hasEnabledActions ? (
          <div className="action-settings-list">
            {actions
              .filter((action) => action.is_on)
              ?.map((setting, index) => (
                <LeaderboardActionSettingCard key={`setting-${index}`} setting={setting} />
              ))}
          </div>
        ) : (
          <div className="leaderboard-small-card">
            <div className="small-card-container">
              <div className="small-card-info">
                <div className="small-card-icon">
                  <Icon name={ICONS.LAYOUT_GRID_EMPTY} size={18} color="var(--gray-400)" />
                </div>
                <Text className="small-card-description">
                  <span>No actions yet</span>
                  <label>There are no actions added yet</label>
                </Text>
              </div>
              <OptionalComponent display={!panel}>
                <Button className="flex ai-center" onClick={editActions} hoverBackgroundColor="var(--gray-700)">
                  <Icon name={ICONS.ADD} size={12} color="var(--gray-400)" />
                  <Text tag="span">Add actions</Text>
                </Button>
              </OptionalComponent>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderboardActionSettings;
